import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.locale('vi');
dayjs.extend(utc);
dayjs.extend(timezone);
export default dayjs;